import {ActionTree, GetterTree, MutationTree} from 'vuex'
import {NotificationsState, Notification} from '@/store/types'
import axios from 'axios'

type NotificationsGetter = GetterTree<NotificationsState, any>
type NotificationsMutation = MutationTree<NotificationsState>
type NotificationsAction = ActionTree<NotificationsState, any>

const store = require('store')

let pagination = {
  currentPage: 0,
  totalPages: 0,
  nextPage: 0,
}

const state: NotificationsState = {
  notificationList: [],
  notification: null,
  countUnread: 0,
  notificationsLoader: false,
}

const getters: NotificationsGetter = {
  notificationList: (state) => state.notificationList,
  notification: (state) => state.notification,
  countUnread: (state) => state.countUnread,
  notificationsLoader: (state) => {
    return state.notificationsLoader
  },
}

const mutations: NotificationsMutation = {
  setNotificationList: (state, notifications) => {
    state.notificationList = notifications.filter((n: any) => n.route.name === 'survey')
  },
  setNotificationsLoader: (state, payload) => {
    state.notificationsLoader = payload
  },
  setNotification: (state, {id, data}) => {
    state.notificationList = state.notificationList.map((n) => n.id === id ? data : n)
  },
  setCountUnread: (state, count) => {
    state.countUnread = count
  },
  addNotifications: (state, payload) => {
    state.notificationList = [...state.notificationList, ...payload]
  },
}

const actions: NotificationsAction = {
  getNotificationList: ({commit}) => {
    const user = store.get('user')
    const url = `me/notifications`
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        commit('setNotificationList', response.data.data)
        pagination = response.data.meta.pagination
        commit('setCountUnread', response.headers.countunread)
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  loadNotifications: ({dispatch, commit}) => {
    return new Promise((resolve, reject) => {
      if (pagination.totalPages === 0) {return}
      if (pagination.currentPage === pagination.totalPages) {return}
      commit('setNotificationsLoader', true)
      axios.get(`me/notifications?page=${pagination.nextPage}`).then((response) => {
        commit('addNotifications', response.data.data)
        pagination = response.data.meta.pagination
        commit('setNotificationsLoader', false)
        resolve(response.data.data)
      })
    })
  },
  markNotificationAsRead: ({commit}, notification) => {
    return new Promise((resolve, reject) => {
      axios.put(`notifications/${notification.id}/read`).then((response) => {
        commit('setNotification', {id: notification.id, data: response.data.data})
        resolve(response.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  readAll: ({commit}) => {
    const user = store.get('user')
    const url = `notifications/read-all?user_id=${user.id}`
    return new Promise((resolve, reject) => {
      axios.put(url).then((response) => {
        commit('setNotificationList', response.data.data)
        resolve(response.data.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
}

export default {
    state,
    getters,
    mutations,
    actions,
}
